module.exports = __webpack_public_path__ + "static/media/card-placeholder-blue.7dbecf26.png";